export default {"src":"/_next/static/media/realTimeTracking.b3ddfd07.svg","height":57,"width":39,"blurWidth":0,"blurHeight":0};